import { Injectable } from '@angular/core';
import _ from 'lodash';

@Injectable({
   providedIn: 'root',
})
export class FaviconService {
   private readonly transparentFaviconLink =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9oFFAADATTAuQQAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAEklEQVQ4y2NgGAWjYBSMAggAAAQQAAGFP6pyAAAAAElFTkSuQmCC';

   public letFaviconBlink(duration: number): void {
      const favicon = this.getFaviconElement();
      if (_.isNil(favicon)) return;

      const href = favicon.href;
      favicon.href = this.transparentFaviconLink;

      setTimeout(() => (favicon.href = href), duration);
   }

   private getFaviconElement(): HTMLLinkElement {
      return document.querySelector('#favicon');
   }
}
